export default class VerbrauchMonitoringPeriodeDTO {

  constructor(json) {
    if (json) {
      this.json = json

      this.start = json.startDate
      this.end = json.endDate
      this.kontingent = json.kontingent
      this.verbrauchs = json.verbrauchs
      this.referenz = json.referenz
    } else {
      this.json = {}
    }
  }

}
